import {EFieldType} from 'entities/metadata';
import {TEntity, TEntityValue} from 'modules/data';
import {combineString} from 'shared/utils/combine-string';

export const getListValue = (
    fieldKey: string = '', type: EFieldType, stringStructure: string = '', entity?: TEntity,
): TEntityValue => {
    if (type === EFieldType.COMBINED_STRING) {
        if (stringStructure) {
            const list = combineString(stringStructure, entity);
            if (list && fieldKey === 'fullName') {
                const fullName = list.split(',');
                if (fullName[0].trim() === '' && fullName[1].trim() === '') {
                    return null;
                }
                if (fullName[0].trim() === '') {
                    return fullName[1];
                }
                if (fullName[1].trim() === '') {
                    return fullName[0];
                }
                return fullName.join(',');
            }
            if (list && fieldKey === 'timeWorkdays') {
                if (list.trim() === '-') {
                    return null;
                }
                return list;
            }
            if (list && fieldKey === 'timeWeekend') {
                if (list.trim() === '-') {
                    return null;
                }
                return list;
            }
            return combineString(stringStructure, entity);
        }
    }

    if (fieldKey === 'frontendVersion') return process.env.REACT_APP_VERSION ?? 'не удалось определить версию';

    return entity ? entity[fieldKey] : undefined;
};
